module.exports = __webpack_public_path__ + "static/media/observer-perspective.4bc12667.png";